<div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-fit-content">
    <ui-kit-empty-state class="mt-24 w-100"
                        [spinnerIds]="spinnerIds"
                        backgroundColor="light"
                        icon="ic_empty_state_no_data"
                        [items]="resolution ? [resolution] : []"
                        [title]="'i18n_af_emptyStateTitleResolutionsNotCreated'"
                        subtitle="i18n_af_emptyStateSubtitleResolutionsNotCreated"/>

    @if (resolution) {
        <mat-expansion-panel class="w-100 mt-24" [expanded]="true">
            <mat-expansion-panel-header class="w-100"
                                        fxLayout="start start">
                <mat-panel-title class="no-wrap t2-semi-bold w-100" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="t2-semi-bold">{{
                            'i18n_af_labelResolutionDate' | translate: {
                                date: resolution.createdDate | date:'dd.MM.yy'
                            }
                        }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <af-status [statusText]="statusLabel(resolution.status)" [status]="resolution.statusStyle"/>
                        @if (!Spinner.isShown('delete_' + resolution.id) && canDelete(resolution)) {
                            <ui-kit-svg
                                class="i-16 ml-16 c-secondary-red-800"
                                name="ic_delete"
                                (click)="$event.stopPropagation(); deleteResolution(resolution)"/>
                        }
                        <ui-kit-spinner class="ml-16" [spinnerIds]="'delete_' + resolution.id" [diameter]="16" [strokeWidth]="3"/>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="common-info-container">
                @for (field of resolution.fields; track field) {
                    <div class="t2 c-primary-gray-600">{{ ('i18n_af_field_resolution#' + field.fieldName) | translate }}</div>
                    <div class="t2 c-primary-gray-900">{{ field.fieldValue }}</div>
                }
                @if (resolution.attachments?.length) {
                    <div class="documents-section">
                        <div class="t2-semi-bold">
                            {{ 'i18n_af_labelAdditionalFiles' | translate }}
                        </div>
                        <af-file-group-preview [attachments]="resolution.attachments"
                                          [showDownloadAll]="true"
                                          [spinnerId]="'documentsDownload_' + resolution.id"/>
                    </div>
                }
            </div>
            @if (resolution.solutionInfo?.length) {
                <div class="solution-info-section">
                    <div class="t2-semi-bold">
                        {{ 'i18n_af_labelSolutionInfo' | translate }}
                    </div>
                    <div class="solution-row solution-row--header mt-16">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_field_solution#fullName' | translate }}</div>
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_field_solution#identificationNumber' | translate }}</div>
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_field_solution#category' | translate }}</div>
                    </div>
                    @for (solution of resolution.solutionInfo; track solution.id) {
                        <div class="solution-row">
                            <div class="t2 c-primary-gray-900 break-word">{{ solution.fullName }}</div>
                            <a class="t2 underlined-text c-primary-green-800"
                               (click)="navigateToSubjects(solution.id)">
                                {{ solution.identificationNumber }}
                            </a>
                            <div class="t2 c-primary-gray-900">{{ ('i18n_af_category#' + solution.category) | translate }}</div>
                        </div>
                    }
                </div>
            }
        </mat-expansion-panel>
    }
</div>
